export const firebaseConfigHomolog = {
  apiKey: process.env.VUE_APP_FIREBASE_HOMOLOG_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_HOMOLOG_AUTH_DOMAIN,
  projectId: process.env.VUE_APP_FIREBASE_HOMOLOG_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_HOMOLOG_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_HOMOLOG_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_HOMOLOG_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_HOMOLOG_MEASUREMENT_ID,
};

export const firebaseConfigProd = {
  apiKey: process.env.VUE_APP_FIREBASE_PROD_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_PROD_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_PROD_DATABASE_URL,
  projectId: process.env.VUE_APP_FIREBASE_PROD_PROJECT_ID,
  storageBucket: process.env.VUE_APP_FIREBASE_PROD_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_PROD_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_PROD_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_PROD_MEASUREMENT_ID,
};
